import '@shui/core/sh-table';

import { Component, booleanAttribute, input, numberAttribute, output, ChangeDetectionStrategy } from '@angular/core';
import { ShTableColumns } from '../sh-table-types';

@Component({
    selector: 'sh-table-head',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.checkbox]': 'checkbox() ? "" : null',
        '[attr.columns]': 'columns() ?? null',
        '[attr.condensed]': 'condensed() ? "" : null',
        '[attr.icon]': 'icon() ? "" : null',
        '[attr.number]': 'number() ? "" : null',
        '[attr.unsortable]': 'unsortable() ? "" : null',
        '(head-ready)': 'headReady.emit($event)',
        '(showarrow)': 'showarrow.emit($event)',
        '(toggle)': 'toggle.emit($event)'
    }
})
export class ShTableHeadComponent {
    /**
     * Gives the cell a fixed width for first-column multi-selection checkboxes.
     * Place an `<sh-checkbox>` inside when using this.
     */
    public readonly checkbox = input(false, { transform: booleanAttribute });

    /** Column width as a fraction of the 24-column grid. */
    public readonly columns = input<ShTableColumns | undefined, string | number | undefined>(undefined, {
        transform: v => (v == null ? undefined : (numberAttribute(v) as ShTableColumns))
    });

    /** Applies condensed spacing to the header cell. */
    public readonly condensed = input(false, { transform: booleanAttribute });

    /** Gives the cell a fixed width of 2 rem; sorting is disabled. Use for icon-only columns. */
    public readonly icon = input(false, { transform: booleanAttribute });

    /** Right-aligns text in the header cell. */

    public readonly number = input(false, { transform: booleanAttribute });

    /** Disables sorting on click for this column. */
    public readonly unsortable = input(false, { transform: booleanAttribute });

    /** Emitted when the head cell is first rendered. */
    public readonly headReady = output<Event>();

    /** Emitted when the sort arrow becomes visible. */
    public readonly showarrow = output<Event>();

    /** Emitted when a sortable head cell is clicked. */
    public readonly toggle = output<Event>();
}
